function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M729.266,5344.608v-6.733H732a1,1,0,0,0,0-2h-2.734V5334a1,1,0,1,0-2,0v1.875h-4.533V5334a1,1,0,1,0-2,0v2.022a5.248,5.248,0,0,0-3.733,5.225,5.177,5.177,0,0,0,3.733,5.107v6.771H718a1,1,0,0,0,0,2h2.734V5357a1,1,0,1,0,2,0v-1.875h4.533V5357a1,1,0,1,0,2,0v-2c2.27-.589,3.733-3.112,3.733-5.516A4.8,4.8,0,0,0,729.266,5344.608Zm-2-6.733v6.624h-4.533v-6.624ZM719,5341.163a3.381,3.381,0,0,1,1.734-3.024v6.108A3.364,3.364,0,0,1,719,5341.163Zm3.734,11.961V5346.5h4.533v6.625Zm6.533-.288V5346.7a2.893,2.893,0,0,1,1.734,2.821A3.97,3.97,0,0,1,729.266,5352.836Z",
  transform: "translate(-717 -5333)",
  fill: "#383a3e"
});

var SvgDollar = function SvgDollar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar.b3848f94.svg";
export { ForwardRef as ReactComponent };